import { createFileRoute } from '@tanstack/react-router';

import { StepEditorMobileDemo } from '@/features/workout-creator/ui/v2/demos/step-editor-mobile-demo';

export const Route = createFileRoute('/login')({
	component: RouteComponent,
});

function RouteComponent() {
	// return <div>Hello &quot;/login&quot;!</div>;
	return <StepEditorMobileDemo />;
}
